module.exports = __webpack_public_path__ + "img/20200514_152057.f0d05b97.jpg";